<template>
  <div class="home-menu">
    <el-row class="content">
      <el-col
        :span="8"
        class="col"
      >
        <span @mouseover="toggleModal">
          <img src="@/assets/index/商品百科.png">
          <div class="title">商品百科</div>
          <div class="tit">(买手)</div>
        </span>
        <Modal ref="modal" />
      </el-col>
      <el-col
        :span="8"
        class="col"
      >
        <span @click="goto('/service/yxzt')">
          <img src="@/assets/index/商品营销.png">
          <div class="title">商品营销</div>
          <div class="tit">(卖手)</div>
        </span>
      </el-col>
      <el-col
        :span="8"
        class="col"
      >
        <span @click="goto('/product/place')">
          <img src="@/assets/index/商品产地.png">
          <div class="title">商品产地</div>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Modal from '@/components/index/Modal'
export default {
  name: 'HomeMenu',
  components: {
    Modal
  },
  methods: {
    goto(path) {
      this.$router.push(path)
    },
    toggleModal() {
      this.$refs.modal.showModal()
    }
  }
}
</script>

<style lang="less" scoped>
.home-menu {
  width: 100%;
  margin: 0 auto;
  background: rgba(250, 250, 250, 1);

  .content {
    z-index: 1000;
    width: 50%;
    margin: 0 auto;
    margin-top: -60px;
    height: 170px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

    .col {
      text-align: center;
      position: relative;
      span{
        display: inline-block;
      }
    }

    img {
      width: 80px;
      height: 80px;
      margin-top: 28px;
      cursor: pointer;
    }

    img:hover {
      width: 100px;
      height: 100px;
      margin-top: 14px;
    }

    .title {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      cursor: pointer;
    }
    .tit{
      font-size: 13px;
      margin-top: 3px;
    }
  }
}
</style>
